export const foodCalculators = [

  // pizza
  {
    name: "Kalkulator Pizza",
    link: "/calculator/id/pizza/",
    description:
      "Kalkulator pizza profesional - hitung jumlah tepung, air, ragi, dan garam yang diperlukan untuk membuat adonan pizza sempurna. Kontrol tingkat hidrasi, jumlah bola adonan, dan berat per bola.",
    showMain: true,
  },
  // ice-cream
  {
    name: "Kalkulator Es Krim",
    link: "/calculator/id/ice-cream/",
    description:
      "Hitung jumlah bahan yang dibutuhkan untuk membuat es krim lezat di rumah. Kalkulator es krim membantu Anda menentukan jumlah susu, gula, krim, dan perasa berdasarkan jumlah porsi yang ingin Anda buat.",
    showMain: true,
  },
  // cake-pan-conversion
  {
    name: "Kalkulator Konversi Ukuran Loyang Kue",
    link: "/calculator/id/cake-pan-conversion/",
    description:
      "Hitung konversi ukuran loyang kue dengan mudah. Kalkulator konversi ukuran loyang kue membantu Anda mengetahui ukuran loyang yang tepat berdasarkan berbagai dimensi, baik loyang bulat, persegi, maupun persegi panjang.",
    showMain: true,
  },
  // perfect-pancake
  {
    name: "Kalkulator Pancake Sempurna",
    link: "/calculator/id/perfect-pancake/",
    description:
      "Dapatkan resep pancake sempurna berdasarkan jumlah porsi yang ingin Anda buat. Kalkulator pancake sempurna membantu Anda menentukan jumlah bahan seperti tepung, susu, telur, dan gula untuk hasil yang lezat dan sempurna.",
    showMain: true,
  },
  // grams-to-cups
  {
    name: "Kalkulator Konversi Gram ke Cangkir",
    link: "/calculator/id/grams-to-cups/",
    description:
      "Hitung konversi gram ke cangkir dengan mudah. Kalkulator konversi gram ke cangkir membantu Anda mengetahui jumlah bahan yang dibutuhkan berdasarkan berat, sehingga memudahkan Anda menyiapkan resep favorit dengan tepat.",
    showMain: true,
  },
  {
    name: "Kalkulator Nilai Gizi Makanan",
    link: "/calculator/id/food-nutrients-calculator/",
    description:
      "Hitung nilai gizi makanan dengan mudah. Kalkulator nilai gizi makanan membantu Anda mengetahui jumlah kalori, protein, lemak, dan karbohidrat dalam makanan favorit Anda, sehingga membantu Anda membuat keputusan diet yang sehat.",
    showMain: true,
  },
  // cooking-measurement
  {
    name: "Kalkulator Konversi Ukuran Masak",
    link: "/calculator/id/cooking-measurement/",
    description:
      "Hitung konversi ukuran memasak dengan mudah. Kalkulator konversi ukuran memasak membantu Anda mengetahui jumlah bahan yang dibutuhkan berdasarkan satuan pengukuran yang berbeda, sehingga memudahkan Anda menyiapkan resep favorit dengan tepat.",
    showMain: true,
  },
  // chocolate-calculator
  {
    name: "Kalkulator Cokelat",
    link: "/calculator/id/chocolate-calculator/",
    description:
      "Hitung jumlah cokelat yang dibutuhkan untuk membuat kue lezat. Kalkulator cokelat membantu Anda menentukan jumlah cokelat yang diperlukan berdasarkan jumlah porsi yang ingin Anda buat, sehingga memudahkan Anda mencapai hasil yang lezat dan sempurna.",
  },
  // donut
  {
    name: "Kalkulator Donat",
    link: "/calculator/id/donut/",
    description:
      "Hitung jumlah bahan yang dibutuhkan untuk membuat donat lezat di rumah. Kalkulator donat membantu Anda menentukan jumlah tepung, gula, ragi, dan garam berdasarkan jumlah porsi yang ingin Anda buat.",
  },

];
export default foodCalculators;